"use client";

import { useState, type ReactNode } from "react";
import { SearchIcon } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@tripcart/traveler-ui/components/popover";

import styles from "./hf-search.module.css";

/** Icon mode of the header search. The popup renders inside this wrapper,
 *  not on `<body>`, so it keeps the header row's `--hf-*` colours. */
export function HfSearchPopover({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  const [container, setContainer] = useState<HTMLSpanElement | null>(null);
  return (
    <span ref={setContainer} className={styles.disclosure}>
      <Popover>
        <PopoverTrigger aria-label={label} className={styles.summary}>
          <SearchIcon aria-hidden className={styles.icon} strokeWidth={1.5} />
        </PopoverTrigger>
        <PopoverContent
          container={container}
          align="end"
          className={styles.panel}
        >
          {children}
        </PopoverContent>
      </Popover>
    </span>
  );
}
